import { defineSlotRecipe } from '@chakra-ui/react';

export const seoLinksSlotRecipe = defineSlotRecipe({
    slots: ['heading', 'seoLinksSection', 'seoLinksSectionTitle', 'tagsWrapper', 'tagBadge'],
    base: {
        seoLinksSection: {
            mt: 6,
        },
        seoLinksSectionTitle: {
            mb: 4,
            fontSize: 'lg',
            fontWeight: 'bold',
        },
        tagsWrapper: {
            flexWrap: 'wrap',
            gap: 2,
        },
        tagBadge: {
            colorPalette: 'gray',
            borderRadius: 'xl',
            px: 3,
            textWrap: 'auto',
        },
    },
});
